const reportOptions = [
  {
    value: 0,
    label: "Reporte de usuario",
  },
  {
    value: 1,
    label: "Reporte de departamento",
  },
];

export { reportOptions };
